/* eslint-disable no-shadow */
import moment from "moment";
import api from '@/service/Login.js';
const state = {
  check: false,
  member: {
    name: "",
    email: "",
    phone: "",
  },
  api_token: "",
  LoginTime: "",
};
const getters = {

}
const actions = {
  async Login({
    commit,
    rootState
  }, data) {
    console.log(rootState);
    let result = {
      status: false
    }
    try {
      const Logindata = await api.Login(data.uniform, data.account, data.password, rootState
        .system.company);
      console.log(Logindata);
      commit("system/setCompany", Logindata.data.result.company, {
        root: true
      });
      commit("setMemberData", {
        status: true,
        data: Logindata.data.result.account
      });
      result.status = true;
    } catch (error) {
      console.log(error);
    }
    return result.status;
  },
  async checkLogin({
    commit,rootState
  }) {
    let check = {}
    try {
      check = await api.checkLogin(rootState.company);

      commit("checkLogin", check.data.result.checkLogin);
      commit("setMember",check.data.result.member);
      // commit("setApiToken", check.data.data.api_token);
      return true;
    } catch (error) {
      console.log(error);
      // check.data.status = false;
      return false;
    }
   
    // console.log("B",sa);

  }
};

const mutations = {
  setApiToken(state, data) {
    state.api_token = data;
    sessionStorage.Authorization = state.api_token;
    localStorage.Authorization = state.api_token;
  },
  checkLogin(state, data) {
    state.check = data;
  },
  setMember(state, data) {
     state.member = {
       name: data.name,
       email: data.email,
       phone: data.phone,
     };
   },
  setMemberData(state, data) {
    state.check = data.status;
    if (state.check) {
      state.member = {
        name: data.data.name,
        email: data.data.email,
        phone: data.data.phone,
      };
      state.api_token = data.data.api_token;
      state.LoginTime = moment();
      localStorage.Authorization = state.api_token;
      console.log(state);
    } else {
      state.member = {
        name: "",
        email: "",
        phone: "",
      };
      state.Authorization = data.api_token;
      state.LoginTime = null;
    }
  },

};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
